// Session-scoped in-memory cache for WelcomePage's feed state (products,
// services, events, media, active tab, scroll position). Plain module-level
// variable — survives SPA route navigation (e.g. visiting a shop and coming
// back) but resets naturally on a full page reload or PWA relaunch, which is
// exactly the desired lifetime: reload only on first visit or app relaunch,
// never just from switching tabs or navigating to a shop and back.
let cache = null;

export const getFeedCache = () => cache;

export const setFeedCache = (partial) => {
  cache = { ...(cache || {}), ...partial };
};

export const clearFeedCache = () => {
  cache = null;
};
